import { frameworkFreeGame } from "../../../core/components/freegame/configuration/freegameconfiguration"
import { freegameAssetConfig } from "../../../data/freegame";
import { basegameAssetConfig } from "../../../data/basegame";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


frameworkFreeGame.data = {

    "POS_X": 0,
    "POS_Y": 0,
    "COMPONENTS": [
        {
            "id": "GameFreeGameContainer_baseLayer",
            "name": "GameFreeGameContainer_baseLayer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "parentLayer": "baseLayer",
            child: [
                {
                    "id": "GameFreeGameComponent",
                    "name": "GameFreeGameBaseLayer",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: [
                        {
                            "name": "image_freegame-fg",
                            "image": "freeGameBgImage",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1922,
                            "height": 1082,
                            "x": 0,
                            "y": 0
                        },

                        {
                            "name": "fg_bottom_grass",
                            "image": "fg_bottom_grass",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1920,
                            "height": 289,
                            "x": 2,
                            "y": 773
                        },







                        {
                            "name": "fg_bottom_grass_mobile",
                            "image": "fg_bottom_grass",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 1920,
                            "height": 289,
                            "x": 2,
                            "y": 773
                        },

                        //  {
                        //      "name": "fg_top_vines",
                        //      "image": "fg_top_vines",
                        //      "type": "Image",
                        //      "class": "",
                        //      "layout": false,
                        //      "uimode": "desktop",
                        //      "visible": true,
                        //      "width": 1234,
                        //      "height": 73,
                        //      "x": 344,
                        //      "y": 47
                        //  },
                        // {
                        //     "name": "basegame_megaways_banner",
                        //     "image": "basegame_megaways_banner",
                        //     "type": "Image",
                        //     "class": "",
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "width": 560,
                        //     "height": 103,
                        //     "x": 675,
                        //     "y": 25
                        // },




                        /*   {
                               "id": "freegameLeave_mobile_container",
                               "name": "freegameLeave_mobile_container",
                               "type": "Container",
                               "class": "",
                               "x": 934,
                               "y": 552,
                               "scale": 0.5,
                               "layout":true,
                               "uimode": "mobile",
                               "filterTypes": [],
                               child: [
                                  
                               {
                               "id": "freegameLeave_mobile",
                               "name": "freegameLeave",
                               "type": "Spine",
                               "x": 0,
                               "y": 0,
                               "width": 1916,
                               "height": 1012,
                              
   
                               //  "scale"
                               "visible": true,
                               "anchor": [0, 0],
                               "spinedata": {
                                   "spinename": "freegameLeave",
                                   "animationname": ["freegame"],
                                   "loop": true,
                                   "timeScale": 0.9
   
                               },
                               "parentLayer": "specialAnimationLayer",
                           },
                               
                               ]
                           },*/

                        {
                            "id": "freegameLeave_desktop",
                            "name": "freegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 552,
                            "width": 1916,
                            "height": 1012,
                            "layout": false,
                            "uimode": "desktop",

                            //  "scale"
                            "visible": true,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "freegameLeave",
                                "animationname": ["freegame"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "freegameLeave_desktop",
                            "name": "freegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 553,
                            "width": 1916,
                            "height": 1012,
                            "layout": false,
                            "uimode": "desktop",

                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "freegameLeave",
                                "animationname": ["rope"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        {
                            "id": "freegameLeave_mobile",
                            "name": "freegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 552,
                            "width": 1916,
                            "height": 1012,
                            "layout": true,
                            "uimode": "mobile",

                            //  "scale"
                            "visible": true,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "freegameLeave",
                                "animationname": ["freegame"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "freegameLeave_mobile",
                            "name": "freegameLeave",
                            "type": "Spine",
                            "x": 934,
                            "y": 553,
                            "width": 1916,
                            "height": 1012,
                            "layout": true,
                            "uimode": "mobile",

                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "freegameLeave",
                                "animationname": ["rope"],
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },














                        {
                            "name": "FG_frame_Image_Desktop",
                            "image": "Fg_frame",
                            "type": "Image",
                            "layout": false,
                            "uimode": "desktop",
                            "class": "",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 1409,
                            "height": 963,
                            "x": 957.5,
                            "y": 506.5
                        },
                        {
                            "name": "FG_frame_Image_mobile",
                            "image": "Fg_frame",
                            "type": "Image",
                            "layout": true,
                            "uimode": "mobile",
                            "class": "",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 1409,
                            "height": 963,
                            "x": 957.5,
                            "y": 527.5
                        },
                        {
                            "name": "header_meter",
                            "image": "header_meter",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 926,
                            "height": 128,
                            "x": 484,
                            "y": 6
                        },









                        {
                            "name": "header_meter_mobile",
                            "image": "header_meter",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 926,
                            "height": 128,
                            "x": 484,
                            "y": 6
                        },
                        //{
                        //    "id": "bgSpine_gamelogo",
                        //    "name": "game_logo",
                        //    "type": "Spine",
                        //    "x": 140,
                        //    "y": 270,
                        //    "width": 263,
                        //    "height": 135,
                        //    "layout": false,
                        //    "uimode": "desktop",
                        //    "visible": true,
                        //    "anchor": [0, 0],
                        //    "spinedata": {
                        //        "spinename": "game_logo",
                        //        "animationname": "animation",
                        //        "loop": true,
                        //        "timeScale": 0.9

                        //    },
                        //},

                    ]
                }
            ]

        },
        {
            "id": "GameFreeGameContainer_specialLayer",
            "name": "GameFreeGameContainer_specialLayer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "parentLayer": "specialAnimationLayer",
            child: [
                {
                    "id": "GameFreeGameComponent",
                    "name": "GameFreeGameSpecialLayer",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: [


                        {
                            "id": "game_logoContainer_desktop",
                            "name": "game_logoContainer_desktop",
                            "type": "Container",
                            "class": "",
                            "x": 202,
                            "y": 157,
                            "layout": false,
                            "uimode": "desktop",
                            "scale": 0.5,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "game_logo_desktop_FG",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,
                                    //  "scale"
                                    "visible": true,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["idol"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "game_logo_desktop",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,
                                    "layout": false,
                                    "uimode": "desktop",
                                    //  "scale"
                                    "visible": false,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["action"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },



                        {
                            "id": "game_logoContainer_mobile",
                            "name": "game_logoContainer_mobile",
                            "type": "Container",
                            "class": "",
                            "x": 202,
                            "y": 157,
                            "layout": true,
                            "uimode": "mobile",
                            "scale": 0.5,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "game_logo_mobile_FG",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,
                                    //  "scale"
                                    "visible": true,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["idol"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "game_logo_mobile",
                                    "name": "game_logo",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 748.65,
                                    "height": 531.86,
                                    //  "scale"
                                    "visible": false,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "game_logo",
                                        "animationname": ["action"],
                                        "loop": true,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },

                        // {
                        //     "name": "fg_grass",
                        //     "image": "fg_grass",
                        //     "type": "Image",
                        //     "class": "",
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "width": 1916,
                        //     "height": 306,
                        //     "x": 2,
                        //     "y": 773
                        // },
                        // {
                        //     "id": "Free_game_vines",
                        //     "name": "Free_game_vines",
                        //     "type": "Spine",
                        //     "x": 960,
                        //     "y": 595,
                        //     "width": 1919,
                        //     "height": 1049,
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "visible": true,
                        //     "anchor": [0, 0],
                        //     "spinedata": {
                        //         "spinename": "Free_game_vines",
                        //         "animationname": "animation",
                        //         "loop": true,
                        //         "timeScale": 0.9

                        //     },
                        // },
                        {
                            "name": "right_meterFrame",
                            "image": "fg_banner",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            "visible": true,
                            "width": 301,
                            "height": 125,
                            "x": 1607,
                            "y": 226
                        },



                        /*{
                              "name": "right_meterFrame_mobile",
                              "image": "right_meterFrame",
                              "type": "Image",
                              "class": "",
                              "layout": true,
                              "uimode": "mobile",
                              "parentLayer": "specialAnimationLayer",
                              "filterTypes": [],
                              "visible": true,
                              "width": 178,
                              "height": 192,
                              "x": 1675,
                              "y": 190
                          },*/
                        //  {
                        //      "name": "multiplierFrame_FG_Image_desktop",
                        //      "image": "multiplierFrameFG",
                        //      "type": "Image",
                        //      "class": "",
                        //      "layout": true,
                        //      "uimode": "desktop",
                        //      "parentLayer": "specialAnimationLayer",
                        //      "filterTypes": [],
                        //      "visible": true,
                        //      "width": 272,
                        //      "height": 248,
                        //      "x": 1655,
                        //      "y": 370
                        //  },
                        //  {
                        //      "name": "multiplierFrame_FG_Image_mob",
                        //      "image": "multiplierFrameFG",
                        //      "type": "Image",
                        //      "class": "",
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "parentLayer": "specialAnimationLayer",
                        //      "filterTypes": [],
                        //      "visible": true,
                        //      "width": 197,
                        //      "height": 159,
                        //      "x": 1712,
                        //      "y": 391
                        //  },


                        {
                            "name": "fg_front_grass_mobile",
                            "image": "fg_front_grass",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 1243,
                            "height": 179,
                            "x": 329,
                            "y": 862
                        },

                        {
                            "id": "fg_bodyBuilderCharecterIdle_desktop",
                            "name": "fg_bodyBuilderCharecterIdle_desktop",
                            "type": "Spine",
                            "x": 1638,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": true,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "fg_bodyBuilderCharacterAction_desktop",
                            "name": "fg_bodyBuilderCharacterAction_desktop",
                            "type": "Spine",
                            "x": 1638,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        {
                            "id": "fg_skeletonCharacterIdle_desktop",
                            "name": "fg_skeletonCharacterIdle_desktop",
                            "type": "Spine",
                            "x": 1684,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "fg_skeletonCharectarAction_desktop",
                            "name": "fg_skeletonCharectarAction_desktop",
                            "type": "Spine",
                            "x": 1684,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": false,
                            "uimode": "desktop",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },




                        {
                            "id": "fg_bodyBuilderCharecterIdle_mobile",
                            "name": "fg_bodyBuilderCharecterIdle_mobile",
                            "type": "Spine",
                            "x": 1538,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": true,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "fg_bodyBuilderCharacterAction_mobile",
                            "name": "fg_bodyBuilderCharacterAction_mobile",
                            "type": "Spine",
                            "x": 1538,
                            "y": 987,
                            "width": 404.12,
                            "height": 596.75,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "bodyBuilderCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        {
                            "id": "fg_skeletonCharacterIdle_mobile",
                            "name": "fg_skeletonCharacterIdle_mobile",
                            "type": "Spine",
                            "x": 1584,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Idle",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "fg_skeletonCharectarAction_mobile",
                            "name": "fg_skeletonCharectarAction_mobile",
                            "type": "Spine",
                            "x": 1584,
                            "y": 987,
                            "width": 311.08,
                            "height": 660.94,
                            "layout": true,
                            "uimode": "mobile",
                            //  "scale"
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "skeletonCharacter",
                                "animationname": "Action",
                                "loop": true,
                                "timeScale": 0.9

                            },
                            "parentLayer": "specialAnimationLayer",
                        },












                        {
                            "id": "fg_animChangeEffect_desktop",
                            "name": "fg_animChangeEffect_desktop",
                            "type": "Spine",
                            "x": 1640,
                            "y": 976,
                            "width": 1039,
                            "height": 1012,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "animChangeEffect",
                                "animationname": "trans",
                                "loop": false,
                                "timeScale": 0.9
                            },
                            "parentLayer": "specialAnimationLayer",
                        },







                        {
                            "id": "fg_animChangeEffect_mobile",
                            "name": "fg_animChangeEffect_mobile",
                            "type": "Spine",
                            "x": 1640,
                            "y": 976,
                            "width": 1039,
                            "height": 1012,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": false,
                            "anchor": [0, 0],
                            "spinedata": {
                                "spinename": "animChangeEffect",
                                "animationname": "trans",
                                "loop": false,
                                "timeScale": 0.9
                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        {
                            "name": "fg_banner_mobile",
                            "image": "fg_banner",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "mobile",
                            "filterTypes": [],
                            "visible": true,
                            "width": 301,
                            "height": 125,
                            "x": 1,
                            "y": 814
                        },






                        {
                            "name": "fg_skeletonCharacterBtn_mobile",
                            "image": "skeletonCharacterBtnMob",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "mobile",
                            "filterTypes": [],
                            "visible": true,
                            "width": 184,
                            "height": 191,
                            "x": 1349,
                            "y": 814
                        },
                        {
                            "name": "fg_bodyBuilderCharacterBtn_mobile",
                            "image": "bodyBuilderCharacterBtnMob",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "mobile",
                            "filterTypes": [],
                            "visible": false,
                            "width": 184,
                            "height": 191,
                            "x": 1349,
                            "y": 814
                        },

                        {
                            "name": "fg_front_grass",
                            "image": "fg_front_grass",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1243,
                            "height": 179,
                            "x": 329,
                            "y": 862
                        },



                        {
                            "id": "text_10_desktop",
                            "name": "text_FreeGame_value1",
                            "type": "Text",
                            "x": 1680,
                            "y": 306,
                            "width": 60,
                            "layout": false,
                            "uimode": "desktop",
                            "text": "00",
                            "scaleToFit": true,
                            "visible": true,
                            "anchor": [1, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 48,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "text_fg_out",
                            "name": "text_fg_out",
                            "type": "Text",
                            "x": 1820,
                            "y": 306,
                            "width": 130,
                            "layout": false,

                            "uimode": "desktop",
                            "text": "freegameText_out",
                            "scaleToFit": true,
                            "visible": true,
                            "anchor": [1, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 50,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        /*    {
                                "id": "text_fg_out_mobile",
                                "name": "text_fg_out_mobile",
                                "type": "Text",
                                "x": 1818,
                                "y": 285,
                                "width": 100,
                                "layout": true,
    
                                "uimode": "mobile",
                                "text": "freegameText_out",
                                "scaleToFit": true,
                                "visible": true,
                                "anchor": [1, 0.5],
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 42,
                                    fontWeight: 'bold',
                                    fill: ['#ffffff', '#ffd200', '#ff4e00'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },*/
                        {
                            "id": "text_11_desktop",
                            "name": "text_FreeGame_OF_label",
                            "type": "Text",
                            "x": 1880,
                            "y": 303,
                            "width": 56,
                            "text": "freegameText3",
                            "visible": true,
                            "layout": false,

                            "uimode": "desktop",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 42,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "text_12_desktop",
                            "name": "text_FreeGame_value2",
                            "type": "Text",
                            "x": 1855,
                            "y": 306,
                            "width": 75,
                            "layout": false,

                            "uimode": "desktop",
                            "visible": true,
                            "text": "",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 50,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "text_10_mobile",
                            "name": "text_FreeGame_value1",
                            "type": "Text",
                            "x": 1736,
                            "y": 289,
                            "width": 70,
                            "layout": true,
                            "uimode": "mobile",
                            "text": "0",
                            "scaleToFit": true,
                            "visible": true,
                            "anchor": [1, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 48,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "text_fg_out",
                            "name": "text_fg_out_mobile",
                            "type": "Text",
                            "x": 1826,
                            "y": 285,
                            "width": 130,
                            "layout": true,
                            "uimode": "mobile",
                            "text": "freegameText_out",
                            "scaleToFit": true,
                            "visible": true,
                            "anchor": [1, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 48,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "text_11_mobile",
                            "name": "text_FreeGame_OF_label_mobile",
                            "type": "Text",
                            "x": 1729,
                            "y": 328,
                            "width": 56,
                            "text": "freegameText3",
                            "visible": true,
                            "layout": true,
                            "uimode": "mobile",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 42,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "text_12_mobile",
                            "name": "text_FreeGame_value2",
                            "type": "Text",
                            "x": 1858,
                            "y": 288,
                            "width": 70,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "text": "0",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 46,
                                fontWeight: 'bold',
                                fill: ['#ffffff', '#ffd200', '#ff4e00'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        {
                            "id": "text_14_desktop",
                            "name": "text_TotalWin_value",
                            "type": "Text",
                            "x": 1078,
                            "y": 1100,
                            "width": 220,
                            "text": "000",
                            "layout": true,
                            "uimode": "desktop",
                            "visible": false,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 36,
                                fill: ['#01f301'],
                                fontWeight: 'bold',
                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        {
                            "id": "Button_1",
                            "name": "btn_setting",
                            "type": objectTypes.Sprite,
                            "buttonMode": false,
                            "uimode": "desktop",
                            "interactive": false,
                            "x": 5,
                            "y": 1025,
                            "height": 64,
                            "width": 64,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'setting_disable.png',
                                out: 'setting_disable.png',
                                down: 'setting_disable.png',
                                disable: 'setting_disable.png',
                                enable: 'setting_disable.png',
                                hover: 'setting_disable.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {},

                        },
                        // {
                        //     "id": "Button_2",
                        //     "name": "btn_gameRule",
                        //     "type": objectTypes.Sprite,
                        //     "buttonMode": false,
                        //     "uimode": "desktop",
                        //     "interactive": false,
                        //     "x": 67,
                        //     "y": 1025,
                        //     "height": 64,
                        //     "width": 64,
                        //     "text": "",
                        //     "visible": true,
                        //     "buttonState": {
                        //         up: 'gamerule_disable.png',
                        //         out: 'gamerule_disable.png',
                        //         down: 'gamerule_disable.png',
                        //         disable: 'gamerule_disable.png',
                        //         enable: 'gamerule_disable.png',
                        //         hover: 'gamerule_disable.png'
                        //     },
                        //     "hitareaVisible": false,
                        //     "shapeVisible": false,
                        //     "shape": {}
                        // },
                        {
                            "id": "Button_3",
                            "name": "btn_sound",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "x": 130,
                            "y": 1025,
                            "height": 60,
                            "width": 60,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'sound_up.png',
                                out: 'sound_up.png',
                                down: 'sound_down.png',
                                disable: 'sound_disable.png',
                                enable: 'sound_up.png',
                                hover: 'sound_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },
                        // {
                        //     "id": "Button_4",
                        //     "name": "btn_soundOff",
                        //     "type": objectTypes.Sprite,
                        //     "buttonMode": true,
                        //     "uimode": "desktop",
                        //     "interactive": true,
                        //     "x": 130,
                        //     "y": 1025,
                        //     "height": 60,
                        //     "width": 60,
                        //     "text": "",
                        //     "visible": true,
                        //     "buttonState": {
                        //         up: 'soundoff_up.png',
                        //         out: 'soundoff_up.png',
                        //         down: 'soundoff_down.png',
                        //         disable: 'soundoff_disable.png',
                        //         enable: 'soundoff_up.png',
                        //         hover: 'soundoff_over.png'
                        //     },
                        //     "hitareaVisible": false,
                        //     "shapeVisible": false,
                        //     "shape": {}
                        // },
                        // {
                        //     "name": "mobileViewBottomBArImage1FG",
                        //     "image": "mobileViewBottomBarImage1",
                        //     "type": "Image",
                        //     "class": "",
                        //     "layout": true,
                        //     "parentLayer": "specialAnimationLayer",
                        //     "uimode": "mobile",
                        //     "filterTypes": [],
                        //     "visible": true,
                        //     "width": 1920,
                        //     "height": 150,
                        //     "x": 0,
                        //     "y": 860
                        // },

                        // {
                        //     "name": "mobileViewBottomBArImage2FG",
                        //     "image": "mobileViewBottomBarImage2",
                        //     "type": "Image",
                        //     "class": "",
                        //     "layout": true,
                        //     "parentLayer": "specialAnimationLayer",
                        //     "uimode": "mobile",
                        //     "filterTypes": [],
                        //     "visible": true,
                        //     "width": 1920,
                        //     "height": 70,
                        //     "x": 0,
                        //     "y": 1010
                        // },



                        //  {
                        //      "id": "text_1_mobile",
                        //      "name": "text_FreeGame_label_mobileFG",
                        //      "type": "Text",
                        //      "x": 469,
                        //      "y": 940,
                        //      "width": 490,
                        //      "text": "freegameText1",
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "visible": true,
                        //      "scaleToFit": true,
                        //      "anchor": [0.5, 0.5],
                        //      "textStyle": {
                        //          fontFamily: 'Arial',
                        //          fontSize: 46,
                        //          fontWeight: 'bold',
                        //          fill: ['#ffffff'],
                        //      },
                        //      "parentLayer": "specialAnimationLayer",
                        //  },
                        //  {
                        //      "id": "text_2_mobile",
                        //      "name": "text_FreeGame_value1_mobileFG",
                        //      "type": "Text",
                        //      "x": 650,
                        //      "y": 940,
                        //      "width": 50,
                        //      "text": "00",
                        //      "visible": true,
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "scaleToFit": true,
                        //      "anchor": [0.5, 0.5],
                        //      "textStyle": {
                        //          fontFamily: 'Arial',
                        //          fontSize: 46,
                        //          fontWeight: 'bold',
                        //          fill: ['#ffffff'],
                        //      },
                        //      "parentLayer": "specialAnimationLayer",
                        //  },
                        //  {
                        //      "id": "text_3_mobile",
                        //      "name": "text_FreeGame_OF_label_mobileFG",
                        //      "type": "Text",
                        //      "x": 668,
                        //      "y": 940,
                        //      "visible": true,
                        //      "width": 76,
                        //      "text": "freegameText3",
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "scaleToFit": true,
                        //      "anchor": [0.5, 0.5],
                        //      "textStyle": {
                        //          fontFamily: 'Arial',
                        //          fontSize: 46,
                        //          fontWeight: 'bold',
                        //          fill: ['#ffffff'],
                        //      },
                        //      "parentLayer": "specialAnimationLayer",
                        //  },
                        //  {
                        //      "id": "text_4_mobile",
                        //      "name": "text_FreeGame_value2_mobileFG",
                        //      "type": "Text",
                        //      "x": 800,
                        //      "y": 940,
                        //      "width": 76,
                        //      "text": "",
                        //      "visible": true,
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "scaleToFit": true,
                        //      "anchor": [0.5, 0.5],
                        //      "textStyle": {
                        //          fontFamily: 'Arial',
                        //          fontSize: 46,
                        //          fontWeight: 'bold',
                        //          fill: ['#ffffff'],
                        //      },
                        //      "parentLayer": "specialAnimationLayer",
                        //  },

                        //  {
                        //      "name": "total_win_meter_fg",
                        //      "image": "total_win_meter_fg",
                        //      "type": "Image",
                        //      "class": "",
                        //      "layout": false,
                        //      "uimode": "desktop",
                        //      "visible": true,
                        //      "width": 314,
                        //      "height": 667,
                        //      "x": 29,
                        //      "y": 327
                        //  },


                        {
                            "name": "total_win_meter_fg_desktop",
                            "image": "total_win_meter_fg",
                            "type": "Image",
                            //"anchor": [0.5, 0.5],
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 314,
                            "height": 667,
                            "x": 29,
                            "y": 327
                        },




                        {
                            "name": "total_win_meter_fg_mobile",
                            "image": "total_win_meter_fg",
                            "type": "Image",
                            //"anchor": [0.5, 0.5],
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 314,
                            "height": 667,
                            "x": 29,
                            "y": 327
                        },
                        {
                            "name": "bottomBarForPortrait",
                            "type": "Graphic",
                            "shape": "rectangle",
                            "visible": true,
                            "layout": true,
                            "uimode": "mobile",
                            "alpha": 0.94,
                            "color": "0x000000",
                            "x": 0,
                            "y": 1750,
                            "width": 1080,
                            "height": 160,

                        },



                        {
                            "id": "total_win_text",
                            "name": "total_win_text",
                            "type": "Text",
                            "layout": false,
                            "uimode": "desktop",
                            "width": 314,
                            "height": 667,
                            "x": 189,
                            "y": 493,
                            "text": "mainScreen_TotalWin",
                            "scaleToFit": true,
                            "visible": true,

                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Impact',
                                fontSize: 31.5,
                                fontStyle: 'bold',
                                fill: ['#f0e700', '#fd9d08'],
                                wordWrap: true,
                                wordWrapWidth: 300,
                                stroke: '#ca0606',
                                strokeThickness: 4,
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,

                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        {
                            "id": "total_win_text_freegame_mobile",
                            "name": "total_win_text_freegame_mobile",
                            "type": "Text",
                            "layout": true,
                            "uimode": "mobile",
                            "width": 400,
                            "height": 667,
                            "x": 189,
                            "y": 493,
                            "text": "mainScreen_TotalWin",
                            "scaleToFit": true,
                            "visible": true,

                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Impact',
                                fontSize: 31.5,
                                fontStyle: 'bold',
                                fill: ['#f0e700', '#fd9d08'],
                                wordWrap: true,
                                wordWrapWidth: 300,
                                stroke: '#ca0606',
                                strokeThickness: 4,
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,

                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        //  {
                        //      "name": "total_win_text",
                        //      "image": "total_win_text",
                        //      "type": "Image",
                        //      "class": "",
                        //      "layout": false,
                        //      "uimode": "desktop",
                        //      "visible": true,
                        //      "width": 221,
                        //      "height": 54,
                        //      "x": 76,
                        //      "y": 468
                        //  },
                        //  {
                        //      "id": "text_5_mobile",
                        //      "name": "text_TotalWin_label_mobileFG",
                        //      "type": "Text",
                        //      "x": 1164,
                        //      "y": 940,
                        //      "width": 490,
                        //      "visible": true,
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "text": "freegameText5",
                        //      "scaleToFit": true,
                        //      "anchor": [0.5, 0.5],
                        //      "textStyle": {
                        //          fontFamily: 'Arial',
                        //          fontSize: 46,
                        //          fontWeight: 'bold',
                        //          fill: ['#ffffff'],
                        //      },
                        //      "parentLayer": "specialAnimationLayer",
                        //  },
                        //  {
                        //      "id": "text_6_mobile",
                        //      "name": "text_TotalWin_value_mobileFG",
                        //      "type": "Text",
                        //      "x": 1400,
                        //      "y": 895,
                        //      "width": 220,
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "text": "00",
                        //      "visible": false,
                        //      "scaleToFit": true,
                        //      "anchor": [0.5, 0.5],
                        //      "textStyle": {
                        //          fontFamily: 'Arial',
                        //          fontSize: 46,
                        //          fill: ['#ffffff'],
                        //          fontWeight: 'bold',
                        //      },
                        //      "parentLayer": "specialAnimationLayer",
                        //  },
                        //  {
                        //      "id": "Button_M1",
                        //      "name": "btn_spin",
                        //      "type": objectTypes.Sprite,
                        //      "interactive": false,
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "x": 1600,
                        //      "y": 322,
                        //      "height": 300,
                        //      "width": 300,
                        //      "text": "",
                        //      "visible": true,
                        //      "buttonMode": false,
                        //      "buttonState": {
                        //          up: 'mobilespin_disable.png',
                        //          out: 'mobilespin_disable.png',
                        //          down: 'mobilespin_disable.png',
                        //          disable: 'mobilespin_disable.png',
                        //          enable: 'mobilespin_disable.png',
                        //          hover: 'mobilespin_disable.png'
                        //      },
                        //      "hitareaVisible": false,
                        //      "shapeVisible": false,
                        //      "shape": {}
                        //  },
                        //{
                        //    "id": "Button_M2",
                        //    "name": "btn_autoplay2FG",
                        //    "type": objectTypes.Sprite,
                        //    "interactive": false,
                        //    "layout": true,
                        //    "uimode": "mobile",
                        //    "x": 1612,
                        //    "y": 252,
                        //    "height": 157,
                        //    "width": 268,
                        //    "text": "",
                        //    "visible": true,
                        //    "buttonMode": false,
                        //    "buttonState": {
                        //        up: 'mobileautoplay_up.png',
                        //        out: 'mobileautoplay_up.png',
                        //        down: 'mobileautoplay_down.png',
                        //        disable: 'mobileautoplay_disable.png',
                        //        enable: 'mobileautoplay_up.png',
                        //        hover: 'mobileautoplay_up.png'
                        //    },
                        //    "hitareaVisible": false,
                        //    "shapeVisible": false,
                        //    "shape": {}
                        //},

                        //{
                        //    "id": "Button_M4",
                        //    "name": "btn_autoplayFG",
                        //    "type": objectTypes.Sprite,
                        //    "buttonMode": false,
                        //    "layout": true,
                        //    "uimode": "mobile",
                        //    "interactive": false,
                        //    "x": 1760,
                        //    "y": 890,
                        //    "height": 81,
                        //    "width": 88,
                        //    "text": "",
                        //    "visible": true,
                        //    "buttonState": {
                        //        up: 'mobilehamburger_disable.png',
                        //        out: 'mobilehamburger_disable.png',
                        //        down: 'mobilehamburger_disable.png',
                        //        disable: 'mobilehamburger_disable.png',
                        //        enable: 'mobilehamburger_disable.png',
                        //        hover: 'mobilehamburger_disable.png'
                        //    },
                        //    "hitareaVisible": false,
                        //    "shapeVisible": false,
                        //    "shape": {}
                        //},
                        // {
                        //     "id": "Button_M5",
                        //     "name": "btn_homeFG",
                        //     "type": objectTypes.Sprite,
                        //     "buttonMode": false,
                        //     "layout": true,
                        //     "uimode": "mobile",
                        //     "interactive": false,
                        //     "x": 80,
                        //     "y": 890,
                        //     "height": 94,
                        //     "width": 102,
                        //     "text": "",
                        //     "visible": true,
                        //     "buttonState": {
                        //         up: 'mobilehome_disable.png',
                        //         out: 'mobilehome_disable.png',
                        //         down: 'mobilehome_disable.png',
                        //         disable: 'mobilehome_disable.png',
                        //         enable: 'mobilehome_disable.png',
                        //         hover: 'mobilehome_disable.png'
                        //     },
                        //     "hitareaVisible": false,
                        //     "shapeVisible": false,
                        //     "shape": {}
                        // },
                        //    {
                        // "id": "GameHorizontalGridContainerTag",
                        //        "name": "HorizontalGridContainer",
                        // "type": "Tag",
                        //        "class": "",
                        // "parentLayer": "specialAnimationLayer",
                        //        "filterTypes": [],
                        // child: []
                        //    },
                        /*  {
                              "id": "text_7_mobile",
                              "name": "Mobiletext_balance_labelFG",
                              "type": "Text",
                              "layout": true,
                              "uimode": "mobile",
                              "x": 170,
                              "y": 1050,
                              "width": 180,
                              "text": "buttonPanelText_3",
                              "scaleToFit": true,
                              "anchor": [0.5, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 36,
                                  fontWeight: 'bold',
                                  fill: ['#666666'],
  
                              },
                              "parentLayer": "specialAnimationLayer",
                          },
                          {
                              "id": "text_8_mobile",
                              "name": "Mobiletext_mobColonSymbol2FG",
                              "layout": true,
                              "uimode": "mobile",
                              "type": "Text",
                              "x": 294,
                              "y": 1048,
                              "width": 18,
                              "text": "buttonPanelText_13",
                              "scaleToFit": true,
                              "anchor": [0.5, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 36,
                                  fontWeight: 'bold',
                                  fill: ['#666666'],
                              },
                              "parentLayer": "specialAnimationLayer",
                          },
                          {
                              "id": "text_9_mobile",
                              "name": "Mobiletext_balance_valueFG",
                              "type": "Text",
                              "layout": true,
                              "uimode": "mobile",
                              "x": 320,
                              "y": 1050,
                              "width": 206,
                              "text": "",
                              "scaleToFit": true,
                              "anchor": [0, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 36,
                                  fill: ['#ffffff'],
  
  
                              },
                              "parentLayer": "specialAnimationLayer",
                          },
  
                          {
                              "id": "text_10_mobile",
                              "name": "Mobiletext_bet_labelFG",
                              "type": "Text",
                              "layout": true,
                              "uimode": "mobile",
                              "x": 1600,
                              "y": 1050,
                              "width": 80,
                              "text": "buttonPanelText_1",
                              "scaleToFit": true,
                              "anchor": [0.5, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 36,
                                  fontWeight: 'bold',
                                  fill: ['#666666'],
                              },
                              "parentLayer": "specialAnimationLayer",
                          },
                          {
                              "id": "text_11_mobile",
                              "name": "Mobiletext_mobColonSymbol3FG",
                              "layout": true,
                              "uimode": "mobile",
                              "type": "Text",
                              "x": 1660,
                              "y": 1048,
                              "width": 18,
                              "text": "buttonPanelText_13",
                              "scaleToFit": true,
                              "anchor": [0.5, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 36,
                                  fontWeight: 'bold',
                                  fill: ['#666666'],
                              },
                              "parentLayer": "specialAnimationLayer",
                          },
                          {
                              "id": "text_12_mobile",
                              "name": "Mobiletext_bet_valueFG",
                              "type": "Text",
                              "layout": true,
                              "uimode": "mobile",
                              "x": 1770,
                              "y": 1050,
                              "width": 140,
                              "text": "MobViewButtonPanelText3",
                              "scaleToFit": true,
                              "anchor": [0, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 36,
                                  fill: ['#ffffff'],
  
                              },
                              "parentLayer": "specialAnimationLayer",
                          },
  
  
                        /*  {
                              "id": "text_13_mobile",
                              "name": "Mobiletext_win_label_FG",
                              "type": "Text",
                              "layout": true,
                              "uimode": "mobile",
                              "x": 795,
                              "y": 940,
                              "width": 140,
                              "text": "buttonPanelText_5",
                              "scaleToFit": true,
                              "anchor": [0.5, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 60,
                                  fontWeight: 'bold',
                                  fill: ['#666666'],
  
                              },
                              "parentLayer": "specialAnimationLayer",
                          },
                          {
                              "id": "text_14_mobile",
                              "name": "Mobiletext_mobColonSymbol1_FG",
                              "layout": true,
                              "uimode": "mobile",
                              "type": "Text",
                              "x": 876,
                              "y": 936,
                              "width": 28,
                              "text": "buttonPanelText_13",
                              "scaleToFit": true,
                              "anchor": [0.5, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 60,
                                  fontWeight: 'bold',
                                  fill: ['#666666'],
                              },
                              "parentLayer": "specialAnimationLayer",
                          },*/
                        {
                            "name": "fg_bodyBuilderCharacterBtn_desktop",
                            "image": "bodyBuilderCharacterBtn",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "desktop",
                            "filterTypes": [],
                            "visible": false,
                            "width": 100,
                            "height": 118,
                            "x": 1402,
                            "y": 874
                        },
                        {
                            "name": "fg_skeletonCharacterBtn_desktop",
                            "image": "skeletonCharacterBtn",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "buttonMode": true,
                            "interactive": true,
                            "uimode": "desktop",
                            "filterTypes": [],
                            "visible": true,
                            "width": 100,
                            "height": 118,
                            "x": 1402,
                            "y": 874
                        },
                        {
                            "id": "btnGlowContainerFg",
                            "name": "btnGlowContainerFg",
                            "type": "Container",
                            "class": "",
                            "x": 1447,
                            "y": 905,
                            "visible": false,
                            "scale": 0.4,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "Fg_btnGlow_desktop",
                                    "name": "Fg_btnGlow_desktop",
                                    "type": "Spine",
                                    "x": 0,
                                    "y": 0,
                                    "width": 228,
                                    "height": 228,
                                    "layout": false,
                                    "uimode": "desktop",
                                    "visible": true,
                                    "anchor": [0, 0],
                                    "spinedata": {
                                        "spinename": "btnGlow",
                                        "animationname": "fx_glow_yellow",
                                        "loop": false,
                                        "timeScale": 0.9

                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },
                        {
                            "id": "text_M9",
                            "name": "startText",
                            "type": "Text",
                            "layout": false,
                            "uimode": "desktop",
                            "x": 1411,
                            "y": 969,
                            "width": 60,
                            "text": "characterSwitch",
                            "visible": true,
                            "scaleToFit": true,
                            "anchor": [0, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 20,
                                fontStyle: 'bold',
                                fill: ['#000000'],

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "text_M9",
                            "name": "startText_mobfg",
                            "type": "Text",
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1407,
                            "y": 969,
                            "width": 90,
                            "text": "characterSwitch_Mobile",
                            "visible": true,
                            "scaleToFit": true,
                            "anchor": [0, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 20,
                                fontStyle: 'bold',
                                fill: ['#000000'],

                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        /* {
                            "name": "FG_textMultiWays_Image_Desktop",
                            "image": "multiwaysTextImage",
                            "type": "Image",
                            "layout": true,
                            "uimode": "desktop",
                            "class": "",
                            "parentLayer": "baseLayer",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "width": 338,
                            "height": 33,
                            "x": 1022,
                            "y": 44,
                        }, */
                        //  {
                        //      "name": "FG_textMultiWays_Image_mobile",
                        //      "image": "multiwaysTextImage",
                        //      "type": "Image",
                        //      "layout": true,
                        //      "uimode": "mobile",
                        //      "class": "",
                        //      "parentLayer": "baseLayer",
                        //      "anchor": [0.5, 0.5],
                        //      "visible": true,
                        //      "width": 338,
                        //      "height": 33,
                        //      "x": 1022,
                        //      "y": 44,
                        //  },
                        {
                            "id": "text_15_mobile",
                            "name": "Mobiletext_win_value_FG",
                            "type": "Text",
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1068,
                            "y": 940,
                            "width": 306,
                            "text": "MobViewButtonPanelText1",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 60,
                                fill: ['#ffffff'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        // {
                        //     "id": "FG_BitMapText_1_desktop",
                        //     "name": "FG_multiwaysText_desktop",
                        //     "type": "BitMapText",
                        //     "x": 820,
                        //     "y": 65,
                        //     "width": 740,
                        //     "text": "0",
                        //     "visible": true,
                        //     "scaleToFit": true,
                        //     "layout": true,
                        //     "uimode": "desktop",
                        //     "textStyle": {
                        //         font: '55px num-export',
                        //         letterSpacing: -5
                        //
                        //     },
                        //     "parentLayer": "specialAnimationLayer",
                        // },
                        // {
                        //     "name": "multiplier_text_desktop",
                        //     "image": "multiplier",
                        //     "type": "Image",
                        //     "class": "",
                        //     "visible": true,
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "width": 186,
                        //     "height": 34,
                        //     "x": 1698,
                        //     "y": 420,
                        // },
                        // {
                        //     "name": "multiplier_text_mobile",
                        //     "image": "multiplier",
                        //     "type": "Image",
                        //     "class": "",
                        //     "layout": true,
                        //     "uimode": "mobile",
                        //     "visible": true,
                        //     "width": 186,
                        //     "height": 34,
                        //     "x": 1718,
                        //     "y": 556,
                        // },
                        // {
                        //     "id": "multiplier_text_desktop",
                        //     "name": "multiplier_text_desktop",
                        //     "type": "Text",
                        //     "layout": false,
                        //     "uimode": "desktop",
                        //     "x": 1810,
                        //     "y": 566,
                        //     "width": 306,
                        //     "text": "freegameText7",
                        //     "scaleToFit": true,
                        //     "visible": true,
                        //     "anchor": [0.5, 0.5],
                        //     "textStyle": {
                        //         fontFamily: 'Arial',
                        //         fontSize: 30,
                        //         fontStyle: 'bold',
                        //         fill: ['#ff4a00', '#ffff00', '#ff6e02'],
                        //         dropShadow: true,
                        //         dropShadowColor: '#000000',
                        //         dropShadowBlur: 2,
                        //         dropShadowAngle: Math.PI / 2,
                        //         dropShadowDistance: 4,
                        //     },
                        //     "parentLayer": "specialAnimationLayer",
                        // },
                        // {
                        //     "id": "multiplier_text_mobile",
                        //     "name": "multiplier_text_mobile",
                        //     "type": "Text",
                        //     "layout": true,
                        //     "uimode": "mobile",
                        //     "x": 1810,
                        //     "y": 566,
                        //     "width": 306,
                        //     "text": "freegameText7",
                        //     "scaleToFit": true,
                        //     "visible": true,
                        //     "anchor": [0.5, 0.5],
                        //     "textStyle": {
                        //         fontFamily: 'Arial',
                        //         fontSize: 30,
                        //         fontStyle: 'bold',
                        //         fill: ['#ff4a00', '#ffff00', '#ff6e02'],
                        //         dropShadow: true,
                        //         dropShadowColor: '#000000',
                        //         dropShadowBlur: 2,
                        //         dropShadowAngle: Math.PI / 2,
                        //         dropShadowDistance: 4,
                        //     },
                        //     "parentLayer": "specialAnimationLayer",
                        // },
                        // {
                        //     "id": "FG_BitMapText_1_mobile",
                        //     "name": "FG_multiwaysText_mobile",
                        //     "type": "BitMapText",
                        //     "x": 786,
                        //     "y": 40,
                        //     "width": 740,
                        //     "text": "0",
                        //     "visible": true,
                        //     "scaleToFit": true,
                        //     "layout": true,
                        //     "uimode": "mobile",
                        //     "textStyle": {
                        //         font: '40px num-export',
                        //         letterSpacing: -5

                        //     },
                        //     "parentLayer": "specialAnimationLayer",
                        // },
                        //{
                        // "id": "multiplierContainerTag",
                        //    "name": "Multiplier",
                        // "type": "Tag",
                        //    "class": "",
                        // "parentLayer": "specialAnimationLayer",
                        //    "filterTypes": [],
                        // child: []
                        //},
                        // {
                        //     "id": "Button_1",
                        //     "name": "multiplierBtn",
                        //     "type": objectTypes.Sprite,
                        //     "buttonMode": true,
                        //     "interactive": true,
                        //     "x": 100,
                        //     "y": 450,
                        //     "width": 200,
                        //     "height": 100,
                        //     "text": "MULTIPLIER",
                        //     "visible": true,
                        //     "anchor": [0.5, 0.5],
                        //     "textStyle": {
                        //         fontFamily: 'Arial',
                        //         fontSize: 60,
                        //         align: "center",
                        //         fontWeight: 'bold',
                        //         fill: ['#ffffff'],
                        //     },
                        //     "buttonState": {
                        //         up: 'post_intro_start_up.png',
                        //         out: 'post_intro_start_up.png',
                        //         down: 'post_intro_start_down.png',
                        //         disable: 'post_intro_start_disable.png',
                        //         enable: 'post_intro_start_up.png',
                        //         hover: 'post_intro_start_over.png'
                        //     },
                        //     "hitareaVisible": false,
                        //     "shapeVisible": false,
                        //     "shape": {}
                        // },



                        /*   {
                              "id": "truncateHitAreaContainerTag",
                              "name": "TruncateHitArea",
                              "type": "Tag",
                              "class": "",
                              "parentLayer": "specialAnimationLayer",
                              "filterTypes": [],
                              child: []
                          }, */
                        /*   {
                              "id": "LockedReelContainer",
                              "name": "LockedReelContainer",
                              "type": "Tag",
                              "class": "",
                              "parentLayer": "specialAnimationLayer",
                              "filterTypes": [],
                              child: []
                          }, */


                        {
                            "name": "soundBackFG",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 51,
                            "y": 369,
                            "height": 126,
                            "width": 126,
                        },
                        {
                            "id": "Button_M6",
                            "name": "btn_soundFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 51,
                            "y": 370,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_sound_on_icon.png',
                                out: 'land_sound_on_icon.png',
                                down: 'land_sound_on_icon.png',
                                disable: 'land_sound_on_icon.png',
                                enable: 'land_sound_on_icon.png',
                                hover: 'land_sound_on_icon.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },
                        {
                            "id": "Button_M7",
                            "name": "btn_soundOffFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 51,
                            "y": 370,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": false,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_sound_off_icon.png',
                                out: 'land_sound_off_icon.png',
                                down: 'land_sound_off_icon.png',
                                disable: 'land_sound_off_icon.png',
                                enable: 'land_sound_off_icon.png',
                                hover: 'land_sound_off_icon.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },



                        {
                            "id": "Button_M14",
                            "name": "btn_spinStokeFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1604,
                            "y": 357,
                            "width": 302,
                            "height": 257,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_spinstroke_disable.png',
                                out: 'land_spinstroke_disable.png',
                                down: 'land_spinstroke_disable.png',
                                disable: 'land_spinstroke_disable.png',
                                enable: 'land_spinstroke_disable.png',
                                hover: 'land_spinstroke_disable.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },

                        {
                            "id": "Button_M2",
                            "name": "btn_spinFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1665,
                            "y": 374,
                            "width": 225,
                            "height": 225,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_spin_disable.png',
                                out: 'land_spin_disable.png',
                                down: 'land_spin_disable.png',
                                disable: 'land_spin_disable.png',
                                enable: 'land_spin_disable.png',
                                hover: 'land_spin_disable.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },


                        {
                            "id": "Button_M10",
                            "name": "btn_autoplayFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1613,
                            "y": 466,
                            "height": 31,
                            "width": 32,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_autoplay_pressed.png',
                                out: 'land_autoplay_pressed.png',
                                down: 'land_autoplay_pressed.png',
                                disable: 'land_autoplay_pressed.png',
                                enable: 'land_autoplay_pressed.png',
                                hover: 'land_autoplay_pressed.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },


                        {
                            "name": "menuBackFG",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 1702,
                            "y": 220,
                            "height": 126,
                            "width": 126,
                        },
                        {
                            "id": "Button_M7",
                            "name": "btn_menuFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1702,
                            "y": 221,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_menu_disable.png',
                                out: 'land_menu_disable.png',
                                down: 'land_menu_disable.png',
                                disable: 'land_menu_disable.png',
                                enable: 'land_menu_disable.png',
                                hover: 'land_menu_disable.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },



                        {
                            "name": "stakeBackFG",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 1702,
                            "y": 621,
                            "height": 126,
                            "width": 126,
                        },
                        {
                            "id": "Button_M9",
                            "name": "btn_stakeFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1702,
                            "y": 621,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_stake_disable_icon.png',
                                out: 'land_stake_disable_icon.png',
                                down: 'land_stake_disable_icon.png',
                                disable: 'land_stake_disable_icon.png',
                                enable: 'land_stake_disable_icon.png',
                                hover: 'land_stake_disable_icon.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },



                        {
                            "name": "ui_base",
                            "image": "ui_base.png",
                            "type": objectTypes.Sprite,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "width": 1920,
                            "height": 84,
                            "x": 0,
                            "y": 996,
                        },
                        {
                            "name": "ui_base_mobile",
                            "image": "ui_base.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "width": 1920,
                            "height": 84,
                            "x": 0,
                            "y": 996,
                        },



                        {
                            "name": "paytableBackFG",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 51,
                            "y": 542,
                            "height": 126,
                            "width": 126,
                        },
                        {
                            "id": "Button_M1",
                            "name": "btn_paytableFG",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 84,
                            "y": 575,
                            "height": 63,
                            "width": 59,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_paytable_disable_icon.png',
                                out: 'land_paytable_disable_icon.png',
                                down: 'land_paytable_disable_icon.png',
                                disable: 'land_paytable_disable_icon.png',
                                enable: 'land_paytable_disable_icon.png',
                                hover: 'land_paytable_disable_icon.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },
                        {
                            "id": "GiantWild",
                            "name": "GiantWild",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "RandomWild",
                            "name": "RandomWild",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "StreakEffectContainer",
                            "name": "StreakEffectContainer",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "SkullContainer",
                            "name": "SkullContainer",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                        {
                            "id": "WinPanelComponent",
                            "name": "winPanel",
                            "type": "Tag",
                            "class": "",
                            "x": 0,
                            "y": 0,
                            "filterTypes": [],
                            child: [

                            ]
                        },
                        {
                            "id": "RetriggerPopup",
                            "name": "RetriggerPopup",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },

                        {
                            "id": "winShowerContainerTag",
                            "name": "WinShower",
                            "type": "Tag",
                            "class": "",
                            "parentLayer": "specialAnimationLayer",
                            "filterTypes": [],
                            child: []
                        },
                    ]
                },
            ]
        }
    ]
}